import { ResultOf } from "gql.tada";
import { GetTermsPageById } from "@queries/archetypes/GetTermsPageById";
import { ColumnLegalSection } from "@components/entries/ColumnLegalSection";

type TermsPageData = NonNullable<
  ResultOf<typeof GetTermsPageById>["termsPage"]
>;

export const TermsPageRenderer = ({ data }: { data: TermsPageData }) => {
  return (
    <>
      {data.termsContent && (
        <ColumnLegalSection
          entry={{ twoColumnRichTextSection: data.termsContent } as any}
        />
      )}
    </>
  );
};
